import { render, staticRenderFns } from "./ManageAccess.vue?vue&type=template&id=14040c36&"
import script from "./ManageAccess.vue?vue&type=script&lang=js&"
export * from "./ManageAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports